import { autobind } from 'core-decorators';
import PropTypes from 'prop-types';
import { Component } from 'react';
import Icon from '/@/components/icon';
import styles from './styles.module.css';

@autobind
export default class ControlApplications extends Component {
    static propTypes = {
        data: PropTypes.arrayOf(
            PropTypes.shape({
                title: PropTypes.string,
                icon: PropTypes.string,
                windows: PropTypes.arrayOf(
                    PropTypes.shape({
                        title: PropTypes.string,
                        items: PropTypes.arrayOf(PropTypes.node).isRequired,
                    })
                ).isRequired,
            })
        ).isRequired,
    };

    render() {
        return (
            <div className={styles.root}>
                {this.props.data.map((stage, index) => (
                    <div key={index} className={styles.stage}>
                        {index > 0 && (
                            <svg className={styles.arrow} viewBox='0 0 20 100' preserveAspectRatio='none'>
                                <polygon points='0,0 0,100 20,50' />
                            </svg>
                        )}
                        {stage.title && (
                            <div className={styles.title}>
                                {stage.icon && <Icon type={stage.icon} size='md' padding={false} />}
                                <div>{stage.title}</div>
                            </div>
                        )}
                        {stage.windows.map((window, index) => (
                            <div key={index} className={styles.window}>
                                {window.title && <div className={styles.title}>{window.title}</div>}
                                <div className={styles.items}>
                                    {window.items.map((item, index) => (
                                        <div key={index} className={styles.item}>
                                            {item}
                                        </div>
                                    ))}
                                </div>
                            </div>
                        ))}
                    </div>
                ))}
            </div>
        );
    }
}
